import { appUrl } from 'utils/wrappers';

import PageableBase from 'app/collections/pageable_base';
import Shipment from 'app/models/shipment';

export default PageableBase.extend({
  model: Shipment,
  key: 'shipments',
  url: appUrl('shipments'),

  initialize(models, { apiMode, dateRange }) {
    this.apiMode = apiMode;
    this.dateRange = dateRange;

    this.listenTo(this.apiMode, 'change:mode', this.resetToFirstPage);
    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      mode: this.apiMode.get('mode'),
      start_datetime: this.dateRange.getStartDatetimeForParamIso(),
      end_datetime: this.dateRange.getDayAfterEndDatetimeForParamIso(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/shipments.js